import map from "lodash/fp/map";
import { mapGetIds, mapKeyValue } from "../../core/transforms";
class Controller {
  constructor($state, $location, $stateParams, $injector) {
    "ngInject";

    this.$state = $state;
    this.$location = $location;
    this.$stateParams = $stateParams;
    this.Captain = $injector.get("Captain");
    this.Events = $injector.get("Events");
    this.ResetFields = $injector.get("ResetFields");
    this.CorporatesTransforms = $injector.get("CorporatesTransforms");

    this.sections = $injector.get("Sections").customersSections;
    this.fields = this.CorporatesTransforms.fields;
    this.filters = this.CorporatesTransforms.filters;
    this.page = this.$stateParams.page;
    this.limit = this.$stateParams.limit;
    this.activeParams = this.$stateParams;

    // With formatters
    const addOptionsFields = map((field) => {
      if (field.hasFormatter) {
        field.formatter =
          field.name === "account_managers" ? mapGetIds : mapKeyValue;
      }
      return field;
    })(this.CorporatesTransforms.addOptions.fields);

    // Use formatters
    this.addOptions = {
      ...this.CorporatesTransforms.addOptions,
      fields: addOptionsFields,
    };

    this.item = this.CorporatesTransforms.item;
    this.newItemModel = {};

    this.addItemEvent = this.Events.getAddEvent("corporates");
    this.paginateEvent = this.Events.getPaginateEvent("corporates");
    this.filterEvent = this.Events.getFilterEvent("corporates");
    this.sortEvent = this.Events.getSortEvent("corporates");
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/corporates/corporates.controller.js